import { MapGeometry, MapsApi, Point } from './interfaces'

export function geometryHasPoints(geometry?: MapGeometry) {
  return (
    (geometry?.shape === 'circle' && geometry.center != null) ||
    (geometry?.shape === 'polygon' && geometry.points.length > 0)
  )
}

export function getGeometriesBoundPoints(geometries: MapGeometry[]) {
  let points: Point[] = []
  geometries.forEach((x) => {
    if (x.shape === 'polygon') points = points.concat(x.points)
    if (x.shape === 'circle') {
      const { lat, lng } = x.center!
      const r = x.radius! / 111139.0 //converts meters to lat/lng degrees
      points = points.concat([
        {
          lat: lat - r,
          lng: lng - r
        },
        {
          lat: lat - r,
          lng: lng + r
        },
        {
          lat: lat + r,
          lng: lng + r
        },
        {
          lat: lat + r,
          lng: lng - r
        }
      ])
    }
  })
  return points
}

export function updateMapBoundaries(api: MapsApi | undefined, points: Point[]) {
  if (api && points && points.length) {
    if (points.length === 1) {
      api.map.setCenter(points[0])
      api.map.setZoom(14)
      return
    }
    const bounds = new api.maps.LatLngBounds()
    points?.forEach(({ lat, lng }) => {
      bounds.extend({ lat, lng })
    })
    api.map.fitBounds(bounds, 50)
  }
}

export function computeDistanceBetween(p1: Point, p2: Point) {
  const { lat: lat1, lng: lon1 } = p1
  const { lat: lat2, lng: lon2 } = p2

  function deg2rad(deg: number) {
    return deg * (Math.PI / 180)
  }

  const R = 6371 // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1) // deg2rad below
  const dLon = deg2rad(lon2 - lon1)
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  const d = R * c * 1000 // distance in m
  return d
}
